<a [href]="createDownload(datastring)" download="{{ filename }}" id="aLink" #link></a>
